module.exports = __webpack_public_path__ + "img/save-01.65ba7186.svg";